
























































































































import Vue from 'vue';
import _ from 'lodash';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';

import { calculoParidade } from '../../utils/functions';
import TheGestacoesAnterioresFormDialog from '../gestacoes/TheGestacoesAnterioresFormDialog.vue';
import TheGestacoesDados from '../gestacoes/TheGestacoesDados.vue';
import TheGestacoesFormAtual from '../gestacoes/TheGestacoesFormAtual.vue';
import TheGestacoesTabelaFinalizadas from '../gestacoes/TheGestacoesTabelaFinalizadas.vue';

export default Vue.extend({
  name: 'ThePacientesDadosGestacoes',
  components: {
    TheGestacoesAnterioresFormDialog,
    TheGestacoesDados,
    TheGestacoesFormAtual,
    TheGestacoesTabelaFinalizadas,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
      showGestacaoAtual: true,
      editGestacaoAtual: false,
      dialogFinalizarGestacao: false,
      showGestacoesAnteriores: true,
    };
  },
  computed: {
    paridade() {
      if (this.paciente) {
        return calculoParidade(this.paciente.gestacoes);
      }
      return null;
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    gestacaoAtual(): Gestacao | null {
      return this.paciente.gestacao_atual;
    },
    gestacoesAnterioes(): Gestacao[] {
      return _.filter(
        this.paciente.gestacoes as Gestacao[],
        gestacao => (!!gestacao.ended),
      );
    },
    theGestacoesFormAtual(): Vue & { preencheForm: () => void } {
      return this.$refs.theGestacoesFormAtual as Vue & {
        preencheForm: () => void,
      };
    },
    theGestacoesFormFinalizar(): Vue & { preencheForm: () => void } {
      return this.$refs.theGestacoesFormFinalizar as Vue & {
        preencheForm: () => void,
      };
    },
  },
  methods: {
    atualizaGestacao(gestacaoAtual: Gestacao): void {
      this.$emit('atualiza-gestacao', gestacaoAtual);
      this.editGestacaoAtual = false;
      this.showGestacaoAtual = true;
    },
    finalizaGestacao(gestacaoAtual: Gestacao): void {
      this.$emit('finaliza-gestacao', gestacaoAtual);
    },
    novaGestacao(novaGestacao: Gestacao): void {
      this.$emit('novaGestacao', novaGestacao);
      this.editGestacaoAtual = false;
      this.showGestacaoAtual = true;
    },
    adicionaGestacaoAnterior(novaGestacao: Gestacao) {
      this.paciente.gestacoes.push(novaGestacao);
    },
    atualizaPaciente(paciente: Paciente) {
      this.$emit('atualizaPaciente', paciente);
    },
    // eslint-disable-next-line func-names
    formGestacaoAtualDebounce: _.debounce(function () { this.formGestacaoAtual(); }, 200),
    formGestacaoAtual() {
      this.theGestacoesFormAtual.preencheForm();
      this.editGestacaoAtual = true;
      this.showGestacaoAtual = true;
    },
    // eslint-disable-next-line func-names
    formGestacaoFinalizarDebounce: _.debounce(function () { this.formGestacaoFinalizar(); }, 200),
    formGestacaoFinalizar() {
      this.theGestacoesFormFinalizar.preencheForm();
      this.dialogFinalizarGestacao = true;
    },
  },
});
